import { Option } from '~/core/shared/types';

export enum NameTitle {
  Mr = 'mr',
  Mrs = 'mrs',
  Ms = 'ms',
  Miss = 'miss',
  Other = 'other',
}

export const NAME_TITLE_OPTIONS: Option<string>[] = [
  {
    label: 'Mr',
    value: NameTitle.Mr,
  },
  {
    label: 'Mrs',
    value: NameTitle.Mrs,
  },
  {
    label: 'Ms',
    value: NameTitle.Ms,
  },
  {
    label: 'Miss',
    value: NameTitle.Miss,
  },
  {
    label: 'Other',
    value: NameTitle.Other,
  },
];
